// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-video-full
{
    position: relative;
    width: calc(100% - 10px);
    height: 100%;
    padding: 5px;
    
}

.player-video
{

    top:0%;
    width: 0%;
    width: 100%;
    height: calc(100% - var(--player-buttons-height));

}

.react-player
{
    position: absolute;
    left: 50%;
    top:50%;
    visibility: hidden;
    
    z-index: 0;
}

.player-layer-video
{
    position: relative;
    left: 0%;
    top:0%;
    width: 100%;
    height: 100%;
    z-index: 1;
    border-radius: 6px;
    border-width: 2px;
    border-style: none;
    border-color: var(--default-icon-color);

}

.player-layer-1
{
    position: absolute;
    left: 0%;
    top:0%;
    width: 100%;
    height: calc(100% - var(--player-buttons-height));
    z-index: 2;

}


.player-layer-2
{
    position: absolute;
    left: 0%;
    top:0%;
    width: 100%;
    height: calc(100% - var(--player-buttons-height));
    z-index: 3;

}


.player-layer-extra
{
    z-index: 4;
    position: absolute;
    left: 0%;
    top:0%;
    width: 100%;
    height: calc(100% - var(--player-buttons-height));
    

}

.player-layer-lisibility
{
    
    position: absolute;
    left: calc(100% - 104px);
    top:0%;
    width: 100px;
    height: 40px;
    background-color: transparent;
    display:block;
    

}


.player-button-full
{
    display: flex;
    align-items: left;
  
    width: 100%;
    top: calc(100% - var(--player-buttons-height));
    height: var(--player-buttons-height);
    z-index: 0;

}




/* Style de la piste (track) */

.sliderVideo {
    appearance: none;
    height: var(--player-buttons-height);
    width: 100%;
  }
  
  .sliderVideo:focus {
    outline: none;
  }
  
  .sliderVideo::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  

  .sliderVideo:disabled::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  


  .sliderVideo:focus::-webkit-slider-runnable-track {
    background: var(--default-icon-color);
  }
  
  .sliderVideo::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  

  .sliderVideo:disabled::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  

  .sliderVideo::-ms-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  
  .sliderVideo::-ms-fill-lower {
    background: var(--default-icon-color);
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  
  .sliderVideo::-ms-fill-upper {
    background: var(--default-icon-color);
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  
  .sliderVideo::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--player-buttons-height)/2);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
  }

  .sliderVideo::-moz-range-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--player-buttons-height)/2);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
  }
  
  .sliderVideo::-webkit-slider-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--player-buttons-height)/2);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: calc(var(--player-buttons-height)/(-4));
    
  }


  .sliderVideo:disabled::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--player-buttons-height)/2);
    width: 8px;
    border-radius: 3px;
    background: var(--default-disable-icon-color);
    cursor: pointer;
  }

  .sliderVideo:disabled::-moz-range-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--player-buttons-height)/2);
    width: 8px;
    border-radius: 3px;
    background: var(--default-disable-icon-color);
    cursor: pointer;
  }
  
  .sliderVideo:disabled::-webkit-slider-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--player-buttons-height)/2);
    width: 8px;
    border-radius: 3px;
    background: var(--default-disable-icon-color);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: calc(var(--player-buttons-height)/(-4));
    
  }




  .sliderVideo:focus::-ms-fill-lower {
    background: var(--default-icon-color);
  }
  
  .sliderVideo:focus::-ms-fill-upper {
    background: var(--default-icon-color);
  }
  
  .range-wrapper {
    background: inherit;
  }`, "",{"version":3,"sources":["webpack://./src/components/bases/videoplayer/videoplayer.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,YAAY;;AAEhB;;AAEA;;;IAGI,MAAM;IACN,SAAS;IACT,WAAW;IACX,iDAAiD;;AAErD;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,kBAAkB;;IAElB,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;;AAE3C;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,iDAAiD;IACjD,UAAU;;AAEd;;;AAGA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,iDAAiD;IACjD,UAAU;;AAEd;;;AAGA;;IAEI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,iDAAiD;;;AAGrD;;AAEA;;;IAGI,kBAAkB;IAClB,wBAAwB;IACxB,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,aAAa;;;AAGjB;;;AAGA;;IAEI,aAAa;IACb,iBAAiB;;IAEjB,WAAW;IACX,8CAA8C;IAC9C,oCAAoC;IACpC,UAAU;;AAEd;;;;;AAKA,8BAA8B;;AAE9B;IAEI,gBAAgB;IAChB,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;;;EAIA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,wBAAwB;IACxB,mDAAmD;;EAErD;;;EAGA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;IACf,wBAAwB;IACxB,mDAAmD;;EAErD;;;;;EAKA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".player-video-full\n{\n    position: relative;\n    width: calc(100% - 10px);\n    height: 100%;\n    padding: 5px;\n    \n}\n\n.player-video\n{\n\n    top:0%;\n    width: 0%;\n    width: 100%;\n    height: calc(100% - var(--player-buttons-height));\n\n}\n\n.react-player\n{\n    position: absolute;\n    left: 50%;\n    top:50%;\n    visibility: hidden;\n    \n    z-index: 0;\n}\n\n.player-layer-video\n{\n    position: relative;\n    left: 0%;\n    top:0%;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    border-radius: 6px;\n    border-width: 2px;\n    border-style: none;\n    border-color: var(--default-icon-color);\n\n}\n\n.player-layer-1\n{\n    position: absolute;\n    left: 0%;\n    top:0%;\n    width: 100%;\n    height: calc(100% - var(--player-buttons-height));\n    z-index: 2;\n\n}\n\n\n.player-layer-2\n{\n    position: absolute;\n    left: 0%;\n    top:0%;\n    width: 100%;\n    height: calc(100% - var(--player-buttons-height));\n    z-index: 3;\n\n}\n\n\n.player-layer-extra\n{\n    z-index: 4;\n    position: absolute;\n    left: 0%;\n    top:0%;\n    width: 100%;\n    height: calc(100% - var(--player-buttons-height));\n    \n\n}\n\n.player-layer-lisibility\n{\n    \n    position: absolute;\n    left: calc(100% - 104px);\n    top:0%;\n    width: 100px;\n    height: 40px;\n    background-color: transparent;\n    display:block;\n    \n\n}\n\n\n.player-button-full\n{\n    display: flex;\n    align-items: left;\n  \n    width: 100%;\n    top: calc(100% - var(--player-buttons-height));\n    height: var(--player-buttons-height);\n    z-index: 0;\n\n}\n\n\n\n\n/* Style de la piste (track) */\n\n.sliderVideo {\n    -webkit-appearance: none;\n    appearance: none;\n    height: var(--player-buttons-height);\n    width: 100%;\n  }\n  \n  .sliderVideo:focus {\n    outline: none;\n  }\n  \n  .sliderVideo::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n\n  .sliderVideo:disabled::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n\n\n  .sliderVideo:focus::-webkit-slider-runnable-track {\n    background: var(--default-icon-color);\n  }\n  \n  .sliderVideo::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n\n  .sliderVideo:disabled::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n\n  .sliderVideo::-ms-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    border-width: 16px 0;\n    color: transparent;\n  }\n  \n  .sliderVideo::-ms-fill-lower {\n    background: var(--default-icon-color);\n    border: 0.2px solid #010101;\n    border-radius: 2.6px;\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  }\n  \n  .sliderVideo::-ms-fill-upper {\n    background: var(--default-icon-color);\n    border: 0.2px solid #010101;\n    border-radius: 2.6px;\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  }\n  \n  .sliderVideo::-ms-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--player-buttons-height)/2);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n  }\n\n  .sliderVideo::-moz-range-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--player-buttons-height)/2);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n  }\n  \n  .sliderVideo::-webkit-slider-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--player-buttons-height)/2);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: calc(var(--player-buttons-height)/(-4));\n    \n  }\n\n\n  .sliderVideo:disabled::-ms-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--player-buttons-height)/2);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-disable-icon-color);\n    cursor: pointer;\n  }\n\n  .sliderVideo:disabled::-moz-range-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--player-buttons-height)/2);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-disable-icon-color);\n    cursor: pointer;\n  }\n  \n  .sliderVideo:disabled::-webkit-slider-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--player-buttons-height)/2);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-disable-icon-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: calc(var(--player-buttons-height)/(-4));\n    \n  }\n\n\n\n\n  .sliderVideo:focus::-ms-fill-lower {\n    background: var(--default-icon-color);\n  }\n  \n  .sliderVideo:focus::-ms-fill-upper {\n    background: var(--default-icon-color);\n  }\n  \n  .range-wrapper {\n    background: inherit;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
